import React from 'react';
import { ConditionalLink, UniversalLink } from '@plone/volto/components'
import { Card, Header } from 'semantic-ui-react';
import PreviewImage from '@plone/volto/components/theme/PreviewImage/PreviewImage';
import { flattenToAppURL } from '@plone/volto/helpers';
import { isInternalURL } from '@plone/volto/helpers/Url/Url';
import { truncateText } from '../../../utils/blocks';

const EXCERPT_MAX_CHARS = 100;

interface CardItem {
  '@id'?: string;
  title: string;
  description?: string;
  image_field?: string;
}

interface CardTemplateProps {
  items: CardItem[];
  isEditMode?: boolean;
}

const CardTemplate = ({ items, isEditMode = false }: CardTemplateProps) => {
  return (
    <>
      <Card.Group itemsPerRow={3} stackable>
        {items.map((item, index) => {
          const itemHref = item['@id'] || '';
          
          return (
            <Card raised key={itemHref || index} className="listing-card">
              <div className="image-wrap">
                <PreviewImage
                  item={item}
                  image_field={item.image_field}
                  alt={item.title}
                />
              </div>

              <Card.Content>
                {item.title && itemHref && (
                  <Header as="h3" textAlign="center">
                    {isInternalURL(itemHref) ? (
                      <ConditionalLink 
                        to={flattenToAppURL(itemHref)} 
                        condition={!isEditMode}
                        className="card-link"
                      >
                        {item.title}
                      </ConditionalLink>
                    ) : (
                      <UniversalLink href={itemHref} className="card-link">
                        {item.title}
                      </UniversalLink>
                    )}
                  </Header>
                )}
                {item.description && (
                  <Card.Description>{truncateText(item.description, EXCERPT_MAX_CHARS)}</Card.Description>
                )}
              </Card.Content>
            </Card>
          );
        })}
      </Card.Group>
    </>
  );
};

export default CardTemplate;